import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 24px;

  box-shadow: 0px 3px 5px 0px rgba(175, 178, 187, 0.2);
  border-radius: ${theme.border.mediumRadius};
  border: 1px solid ${theme.colors.gray100};
  background-color: ${theme.colors.white};

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 768px) {
    width: calc(100% - 400px);
    margin: 0 auto;
    margin-bottom: 32px;
  }
`

export const SearchSvg = styled.div`
  width: 24px;
  height: 24px;

  svg {
    circle {
      stroke: ${theme.colors.gray900};
    }
    path {
      stroke: ${theme.colors.gray900};
    }
  }
`

export const Content = styled.div`
  margin-left: 16px;

  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const Specialties = styled.div`
  font-size: ${theme.font.sizes.medium};
  color: ${theme.colors.gray900};
  font-weight: ${theme.font.medium};

  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const OthersFilters = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  color: ${theme.colors.gray500};
  font-weight: ${theme.font.normal};

  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
`

export const Filter = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CircleDivisor = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${theme.colors.gray500};

  flex-shrink: 0;
`
